module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button":{"startTask":"Start next task","getDependentVisa":"Start dependant visa"}}}')
  delete Component.options._Ctor
}
